/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import { types } from "./actions";

const initialState = {
  list: [],
  javascriptList: [],
  error: null,
  javascriptListLoading: false,
  javascriptListLoaded: false,
  javascriptTotal: 0,
  loading: false,
  loaded: false,
  isLoading: false,
  isLoaded: false,
  total: 0,
  currentCollector: {},
  togglingStatus: false,
  toggleStatusResponse: null,
  toggleStatusError: null,
  successResponse: null,
  entities: {},
  currentCollectorApiKey: {},
  filter: null,
  currentCollectorDel: {},
  collectorConfigStats: {},
  mediaPluginsList: [],
  mediaPluginsListError: null,
  createCollectorConfigSuccessResponse: null,
  createCollectorConfigFailedResponse: null,
  platformList: [],
  platformListLoading: false,
  platformListLoaded: false,
  collectorChangeLogLoading: false,
  collectorChangeLogLoaded: false,
  collectorChangeLog: [],
  adFrameworkList: [],
  adFrameworkListLoaded: false,
  updateToLatestLoading: false,
  updateToLatestLoaded: true,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_COLLECTORS: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case types.FETCH_COLLECTORS_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload,
      };
    }
    case types.FETCH_COLLECTORS_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    case types.FETCH_JAVASCRIPT_COLLECTORS: {
      return {
        ...state,
        javascriptListLoading: true,
        javascriptListLoaded: false,
      };
    }
    case types.FETCH_JAVASCRIPT_COLLECTORS_SUCCESS: {
      return {
        ...state,
        javascriptListLoading: false,
        javascriptListLoaded: true,
        javascriptList: action.payload.list,
        javascriptTotal: action.payload.total,
      };
    }
    case types.FETCH_JAVASCRIPT_COLLECTORS_FAILED: {
      return {
        ...state,
        javascriptListLoading: false,
        javascriptListLoaded: true,
        error: action.payload,
      };
    }
    case types.LOAD_MORE_COLLECTORS_SUCCESS:
      return {
        ...state,
        list: [...state.list, ...action.payload],
        isLoading: false,
      };
    case types.LOAD_MORE_COLLECTORS_FAILED:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };
    case types.LOAD_MORE_JAVASCRIPT_COLLECTORS_SUCCESS:
      return {
        ...state,
        javascriptList: [...state.javascriptList, ...action.payload],
        javascriptListLoaded: true,
      };
    case types.LOAD_MORE_JAVASCRIPT_COLLECTORS_FAILED:
      return {
        ...state,
        error: action.payload,
        javascriptListLoaded: true,
      };
    case types.FORBIDDEN_COLLECTOR: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    case types.FETCH_A_COLLECTOR: {
      /* istanbul ignore next */
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case types.REMOVE_COLLECTOR: {
      /* istanbul ignore next */
      return {
        ...state,
        currentCollector: {},
        successResponse: null,
        currentCollectorApiKey: {},
        error: null,
      };
    }
    case types.FETCH_A_COLLECTOR_SUCCESS: {
      /* istanbul ignore next */
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        currentCollector: action.payload,
      };
    }
    case types.FETCH_A_COLLECTOR_FAILED: {
      /* istanbul ignore next */
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    case types.FETCH_COLLECTOR_OF_DATAPIPE_SUCCESS: {
      /* istanbul ignore next */
      return {
        ...state,
        loading: false,
        loaded: true,
        entities: {
          ...state.entities,
          [action.payload.id]: action.payload,
        },
      };
    }
    case types.FETCH_COLLECTOR_OF_DATAPIPE_FAIL: {
      /* istanbul ignore next */
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    case types.CREATE_COLLECTOR: {
      /* istanbul ignore next */

      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case types.CREATE_COLLECTOR_SUCCESS: {
      /* istanbul ignore next */

      return {
        ...state,
        loading: false,
        loaded: true,
        successResponse: action.payload,
      };
    }
    case types.CREATE_COLLECTOR_FAILED: {
      /* istanbul ignore next */

      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    case types.ENABLE_COLLECTOR: {
      return {
        ...state,
        togglingStatus: true,
        toggleStatusResponse: null,
        toggleStatusError: null,
      };
    }
    case types.DISABLE_COLLECTOR: {
      /* istanbul ignore next */

      return {
        ...state,
        togglingStatus: true,
        toggleStatusResponse: null,
        toggleStatusError: null,
      };
    }
    case types.ENABLE_COLLECTOR_SUCCESS: {
      /* istanbul ignore next */

      return {
        ...state,
        togglingStatus: false,
        toggleStatusResponse: action.payload,
        toggleStatusError: null,
      };
    }
    case types.DISABLE_COLLECTOR_SUCCESS: {
      /* istanbul ignore next */

      return {
        ...state,
        togglingStatus: false,
        toggleStatusResponse: action.payload,
        toggleStatusError: null,
      };
    }
    case types.ENABLE_COLLECTOR_FAILED: {
      /* istanbul ignore next */

      return {
        ...state,
        togglingStatus: false,
        toggleStatusResponse: null,
        toggleStatusError: action.payload,
      };
    }
    case types.DISABLE_COLLECTOR_FAILED: {
      /* istanbul ignore next */

      return {
        ...state,
        togglingStatus: false,
        toggleStatusResponse: null,
        toggleStatusError: action.payload,
      };
    }
    case types.FETCH_COLLECTOR_APIKEY: {
      return {
        ...state,
        apiKeyLoading: true,
        apiKeyLoaded: false,
      };
    }
    case types.FETCH_COLLECTOR_APIKEY_SUCCESS: {
      return {
        ...state,
        apiKeyLoading: false,
        apiKeyLoaded: true,
        currentCollectorApiKey: action.payload,
      };
    }
    case types.UNSET_API_KEY: {
      return {
        ...state,
        apiKeyLoading: false,
        apiKeyLoaded: true,
        currentCollectorApiKey: null,
      };
    }
    case types.FETCH_COLLECTOR_APIKEY_FAILED: {
      return {
        ...state,
        apiKeyLoading: false,
        apiKeyLoaded: true,
        error: action.payload,
      };
    }
    case types.REGENERATE_COLLECTOR_APIKEY: {
      return {
        ...state,
        apiKeyLoading: true,
        apiKeyLoaded: false,
      };
    }
    case types.REGENERATE_COLLECTOR_APIKEY_SUCCESS: {
      return {
        ...state,
        apiKeyLoading: false,
        apiKeyLoaded: true,
        currentCollectorApiKey: action.payload,
      };
    }
    case types.REGENERATE_COLLECTOR_APIKEY_FAILED: {
      return {
        ...state,
        apiKeyLoading: false,
        apiKeyLoaded: true,
        error: action.payload,
      };
    }
    // new
    case types.SET_COLLECTOR_FILTER_ACTIVE_DISABLE: {
      return {
        ...state,
        filter: action.payload,
      };
    }
    case types.REMOVE_COLLECTOR_FILTER_ACTIVE_DISABLE: {
      return {
        ...state,
        filter: null,
      };
    }
    case types.FETCH_A_COLLECTOR_DEL: {
      /* istanbul ignore next */
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case types.FETCH_A_COLLECTOR_DEL_SUCCESS: {
      /* istanbul ignore next */
      return {
        ...state,
        loading: false,
        loaded: true,
        currentCollectorDel: action.payload,
      };
    }
    case types.FETCH_A_COLLECTOR_DEL_FAILED: {
      /* istanbul ignore next */
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    case types.DELETE_COLLECTOR: {
      return {
        ...state,
        loaded: true,
        loading: false,
        error: null,
      };
    }
    case types.DELETE_COLLECTOR_SUCCESS: {
      return {
        ...state,
        loaded: false,
        loading: true,
        successResponse: action.payload,
      };
    }
    case types.DELETE_COLLECTOR_FAILED: {
      return {
        ...state,
        loaded: false,
        loading: true,
        error: action.payload,
      };
    }
    case types.REMOVE_DEL_COLLECTOR: {
      return {
        ...state,
        currentCollectorDel: {},
        successResponse: null,
      };
    }
    case types.CLEAR_COLLECTOR: {
      return {
        ...initialState,
      };
    }
    case types.UPDATE_COLLECTOR: {
      /* istanbul ignore next */
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        ...(action?.payload?.collector?.updateToLatest && {
          updateToLatestLoading: true,
          updateToLatestLoaded: false,
        }),
      };
    }
    case types.UPDATE_COLLECTOR_SUCCESS: {
      /* istanbul ignore next */

      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        successResponse: action.payload,
        updateToLatestLoading: false,
        updateToLatestLoaded: true,
      };
    }
    case types.UPDATE_COLLECTOR_FAILED: {
      /* istanbul ignore next */

      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload,
        updateToLatestLoading: false,
        updateToLatestLoaded: true,
      };
    }

    case types.UPDATE_COLLECTOR_LIST: {
      return {
        ...state,
        list: state.list.map((value) =>
          value.id === action.payload.collector.configId
            ? {
                ...value,
                projectId: action.payload.collector.projectId,
                projectName:
                  action.payload.collector.projectId !== null
                    ? action.payload.projectName
                    : null,
              }
            : value,
        ),
      };
    }
    case types.FETCH_A_COLLECTOR_CONFIG_STATS: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };
    }
    case types.FETCH_A_COLLECTOR_CONFIG_STATS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        collectorConfigStats: action.payload,
      };
    }
    case types.FETCH_A_COLLECTOR_CONFIG_STATS_FAILED: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload,
      };
    }
    case types.CLEAR_COLLECTOR_CONFIG_STATS: {
      return {
        ...state,
        collectorConfigStats: {},
        isLoading: false,
        isLoaded: false,
        error: null,
      };
    }
    case types.UPDATE_LINKED_COLLECTOR: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };
    }
    case types.UPDATE_LINKED_COLLECTOR_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        successResponse: action.payload,
      };
    }
    case types.UPDATE_LINKED_COLLECTOR_FAILED: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload,
      };
    }
    case types.FETCH_PLATFORMS: {
      return {
        ...state,
        platformList: [],
        platformListLoading: true,
        platformListLoaded: false,
        createCollectorConfigSuccessResponse: null,
        createCollectorConfigFailedResponse: null,
      };
    }
    case types.FETCH_PLATFORMS_SUCCESS: {
      return {
        ...state,
        platformList: action.payload,
        platformListLoading: false,
        platformListLoaded: true,
      };
    }
    case types.FETCH_PLATFORMS_FAILED: {
      return {
        ...state,
        platformList: [],
        platformListLoading: false,
        platformListLoaded: true,
      };
    }
    case types.FETCH_MEDIA_PLUGINS: {
      return {
        ...state,
        createCollectorConfigSuccessResponse: null,
        createCollectorConfigFailedResponse: null,
      };
    }
    case types.FETCH_MEDIA_PLUGINS_SUCCESS: {
      return {
        ...state,
        mediaPluginsList: action.payload?.data,
      };
    }
    case types.FETCH_MEDIA_PLUGINS_FAILED: {
      return {
        ...state,
        mediaPluginsListError: action.payload,
        mediaPluginsList: [],
      };
    }
    case types.CLEAR_MEDIA_PLUGINS_LIST: {
      return {
        ...state,
        mediaPluginsList: null,
        mediaPluginsListError: null,
        createCollectorConfigSuccessResponse: null,
        createCollectorConfigFailedResponse: null,
      };
    }
    case types.CREATE_COLLECTOR_CONFIGURATION: {
      return {
        ...state,
        createCollectorConfigSuccessResponse: null,
        createCollectorConfigFailedResponse: null,
      };
    }
    case types.CREATE_COLLECTOR_CONFIGURATION_SUCCESS: {
      return {
        ...state,
        createCollectorConfigSuccessResponse: action.payload,
      };
    }
    case types.CREATE_COLLECTOR_CONFIGURATION_FAILED: {
      return {
        ...state,
        createCollectorConfigFailedResponse: action.payload?.data?.message,
      };
    }
    case types.CLEAR_COLLECTOR_CONFIGURATION_RESPONSE: {
      return {
        ...state,
        createCollectorConfigFailedResponse: null,
        createCollectorConfigSuccessResponse: null,
      };
    }
    case types.CLEAR_COLLECTOR_LIST: {
      return {
        ...state,
        list: [],
        javascriptListLoading: false,
        javascriptListLoaded: false,
      };
    }
    case types.CLEAR_JAVASCRIPT_COLLECTOR_LIST: {
      return {
        ...state,
        javascriptListLoaded: false,
        javascriptListLoading: false,
        javascriptList: [],
      };
    }
    case types.FETCH_COLLECTOR_LOGS: {
      return {
        ...state,
        collectorChangeLogLoading: true,
        collectorChangeLogLoaded: false,
        list: [],
      };
    }
    case types.FETCH_COLLECTOR_LOGS_SUCCESS: {
      return {
        ...state,
        collectorChangeLogLoading: false,
        collectorChangeLogLoaded: true,
        collectorChangeLog: action.payload,
      };
    }
    case types.FETCH_COLLECTOR_LOGS_FAILED: {
      return {
        ...state,
        collectorChangeLogLoading: false,
        collectorChangeLogLoaded: true,
        collectorChangeLog: [],
      };
    }
    case types.FETCH_A_COLLECTOR_ADFRAMEWORK: {
      return {
        ...state,
        adFrameworkListLoaded: false,
        adFrameworkList: [],
        error: null,
      };
    }
    case types.FETCH_A_COLLECTOR_ADFRAMEWORK_SUCCESS: {
      return {
        ...state,
        adFrameworkListLoaded: true,
        adFrameworkList: action.payload,
        error: null,
      };
    }
    case types.FETCH_A_COLLECTOR_ADFRAMEWORK_FAILED: {
      return {
        ...state,
        adFrameworkListLoaded: true,
        adFrameworkList: [],
        error: action.payload,
      };
    }
    default:
      return state;
  }
}
